import messages from '../../../../locale/messages';

const validate = values => {

  const errors = {}

  if (!values.earningTitle) {
    errors.earningTitle = messages.required;
  } else if (values.earningTitle.trim() == "") {
    errors.earningTitle = messages.required;
  } else if (values.earningTitle && values.earningTitle.length > 200) {
    errors.earningTitle = messages.exceedLimit;
  }

  if (!values.earningContent) {
    errors.earningContent = messages.required;
  } else if (values.earningContent.trim() == "") {
    errors.earningContent = messages.required;
  } else if (values.earningContent && values.earningContent.length > 400) {
    errors.earningContent = messages.exceedLimit;
  }


  return errors
}

export default validate;